import {useQuery} from 'react-query';
import {getReclamationBills} from '../../../app/pages/dashboard/api';
import {ReclamationBill} from '../../../app/interfaces/bill';

const RECLAMATION_BILLS_QUERY_KEY = 'reclamation-bills';


export const useGetReclamationBills = () => {
  return useQuery<ReclamationBill[], unknown, ReclamationBill[]>(
    RECLAMATION_BILLS_QUERY_KEY,
    async () => getReclamationBills(),
  );
};
